import { createApiSlice } from "@common";
import {
    CURD_LEAD_QUALIFICATION_STATUS
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addLeadQualificationStatus",
        method: "post",
        url: CURD_LEAD_QUALIFICATION_STATUS,
        stateKey: "message",
    },
    {
        name: "getLeadQualificationStatus",
        method: "get",
        url: CURD_LEAD_QUALIFICATION_STATUS,
        stateKey: "data",
    },
    {
        name: "updateLeadQualificationStatus",
        method: "put",
        url: CURD_LEAD_QUALIFICATION_STATUS,
        stateKey: "message",
    },
    {
        name: "deleteLeadQualificationStatus",
        method: "delete",
        url: CURD_LEAD_QUALIFICATION_STATUS,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "leadQualificationStatus",
    apiConfig,
    customReducers,
);
const leadQualificationStatusSlice = slice;
// Export the slice's reducer
export default leadQualificationStatusSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addLeadQualificationStatus,
    getLeadQualificationStatus,
    updateLeadQualificationStatus,
    deleteLeadQualificationStatus
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
